// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../config/screen';

export const Container = styled.div`
  height: 100%;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 1rem 0 2rem 0;
`;

export const CardContent = styled.div`
  width: 100%;

  @media (min-width: ${BREAKPOINTS.lg}px) {
    width: 296px;
  };
`;

export const DiagnosticsSection = styled.div`
  margin-top: 1rem;
`;

export const DiagnosticsCardsContainer = styled.div`
  display: flex;
  gap: 16px;
  padding-top: 1rem;
`;

export const DignosticsTextContainer = styled.div`
  padding-bottom: 1rem;
`;
